import { Flex, Switch, SwitchProps } from 'antd'
import Text from 'shared/components/typography/Text'
import { useId } from 'react'
import s from './Toggle.module.css'

interface IToggleProps extends SwitchProps {
  label?: string
}

function Toggle({ label, id: propsId, ...switchProps }: IToggleProps) {
  const generatedId = useId()
  const id = propsId || generatedId

  return (
    <Flex gap={8} align="center">
      <Switch {...switchProps} id={id} />
      {label && (
        <label htmlFor={id} className={s.label}>
          <Text fontSize={14} fontType="body" color="var(--grey-100)">
            {label}
          </Text>
        </label>
      )}
    </Flex>
  )
}

export default Toggle
